"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Evexia API
 * OpenAPI Spec for Evexia APIs
 *
 * The version of the OpenAPI document: 1.0
 * Contact: ch_engineering@calm.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CohortApi = exports.CohortApiFactory = exports.CohortApiFp = exports.CohortApiAxiosParamCreator = void 0;
const tslib_1 = require("tslib");
const axios_1 = tslib_1.__importDefault(require("axios"));
// @ts-ignore
const base_1 = require("../base");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
/**
 * CohortApi - axios parameter creator
 */
const CohortApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Returns the cohort configuration.
         * @param {string} name The cohort name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCohortByNameV1: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ name }, options = {}) {
            // verify required parameter 'name' is not null or undefined
            (0, common_1.assertParamExists)('getCohortByNameV1', 'name', name);
            const localVarPath = `/v1/cohorts/{name}`.replace('{name}', encodeURIComponent(String(name)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Accept'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/cohorts/{name}`,
                sdkMethod: 'getCohortByNameV1',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Admin Only - Sets the cohort for a circle. Admin only access
         * @param {number} recipientId A ID of the recipient self circle
         * @param {CircleUpdateCircleRequest} circleUpdateCircleRequest Create circle request
         * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchCircleCohortV1: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ recipientId, circleUpdateCircleRequest, circleAuthorizationToken, }, options = {}) {
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('patchCircleCohortV1', 'recipientId', recipientId);
            // verify required parameter 'circleUpdateCircleRequest' is not null or undefined
            (0, common_1.assertParamExists)('patchCircleCohortV1', 'circleUpdateCircleRequest', circleUpdateCircleRequest);
            const localVarPath = `/v1/circles/{recipient_id}`.replace('{recipient_id}', encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (circleAuthorizationToken != null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/circles/{recipient_id}`,
                sdkMethod: 'patchCircleCohortV1',
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(circleUpdateCircleRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.CohortApiAxiosParamCreator = CohortApiAxiosParamCreator;
/**
 * CohortApi - functional programming interface
 */
const CohortApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.CohortApiAxiosParamCreator)(configuration);
    return {
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Returns the cohort configuration.
         * @param {string} name The cohort name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCohortByNameV1(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getCohortByNameV1(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CohortApi.getCohortByNameV1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Admin Only - Sets the cohort for a circle. Admin only access
         * @param {number} recipientId A ID of the recipient self circle
         * @param {CircleUpdateCircleRequest} circleUpdateCircleRequest Create circle request
         * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchCircleCohortV1(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.patchCircleCohortV1(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CohortApi.patchCircleCohortV1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.CohortApiFp = CohortApiFp;
/**
 * CohortApi - factory interface
 */
const CohortApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.CohortApiFp)(configuration);
    return {
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Returns the cohort configuration.
         * @param {string} name The cohort name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCohortByNameV1(params, options) {
            return localVarFp
                .getCohortByNameV1(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Admin Only - Sets the cohort for a circle. Admin only access
         * @param {number} recipientId A ID of the recipient self circle
         * @param {CircleUpdateCircleRequest} circleUpdateCircleRequest Create circle request
         * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchCircleCohortV1(params, options) {
            return localVarFp
                .patchCircleCohortV1(params, options)
                .then((request) => request(axios, basePath));
        },
    };
};
exports.CohortApiFactory = CohortApiFactory;
/**
 * CohortApi - object-oriented interface
 */
class CohortApi extends base_1.BaseAPI {
    /**
     * URL `/v1/cohorts/{name}`
     * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
     * @summary Returns the cohort configuration.
     * @param {string} name The cohort name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCohortByNameV1(params, options) {
        return (0, exports.CohortApiFp)(this.configuration)
            .getCohortByNameV1(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/circles/{recipient_id}`
     * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
     * @summary Admin Only - Sets the cohort for a circle. Admin only access
     * @param {number} recipientId A ID of the recipient self circle
     * @param {CircleUpdateCircleRequest} circleUpdateCircleRequest Create circle request
     * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchCircleCohortV1(params, options) {
        return (0, exports.CohortApiFp)(this.configuration)
            .patchCircleCohortV1(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
exports.CohortApi = CohortApi;
//# sourceMappingURL=cohort-api.js.map